export default class InputComponent {
  constructor({
    component: {
      input = false,
      textarea = false,
    },
    type = 'text',
    height = 1,
    placeholder = 'Zadaj text...',
    data,
  }) {
    this.component = {
      input,
      textarea,
    }
    this.type = type
    this.height = height
    this.placeholder = placeholder
    this.data = data
  }
}